// Shared with the web app. Other web code invalidates these keys, so they must not change.
export const queryKeys = {
  userAccess: (userId) => ['user_access', userId],
  userProgress: (userId, courseId) => ['user_progress', userId, courseId],
  userAllProgress: (userId) => ['user_progress', userId, 'all'],
  quizResponses: (userId, courseId) => ['quiz_responses', userId, courseId],
  organization: (orgName) => ['organizations', orgName],
  organizationBySubdomain: (subdomain) => ['organizations', 'subdomain', subdomain],
  enrollments: (userId, options) => ['enrollments', userId, options],
  enrollmentStatus: (userId, courseId) => ['enrollments', userId, courseId, 'status'],
  enrollmentDetails: (userId, courseId) => ['enrollments', userId, courseId, 'details'],
  enrollmentCount: (courseId) => ['courses', courseId, 'enrollment_count'],
  legacyEnrolledCourses: (userId) => ['legacy-enrolled-courses', userId],
  catalogCourses: ({ userId, organization, isSuperAdmin, courseVisibility, publicOnly }) => [
    'catalog-courses', userId, organization, isSuperAdmin, courseVisibility, publicOnly,
  ],
  marketplaceCourses: ({ userId, organization, isSuperAdmin, courseVisibility, publicOnly }) => [
    'marketplace-courses', userId, organization, isSuperAdmin, courseVisibility, publicOnly,
  ],
  dashboardRecommendations: (userId) => ['dashboard-recommendations', userId],
  learnerMemory: (userId) => ['learner-memory', userId],
  roleReadiness: (userId) => ['role-readiness', userId],
  streaks: (userId) => ['gamification', 'streaks', userId],
  accessScope: () => ['access-scope', 'me'],
  planSummary: (userId) => ['dashboard-plan-summary', userId],
  dashboardStats: (userId, courseKey) => ['dashboard-stats', userId, courseKey],
  assessmentsAvailable: (userId) => ['assessments-available', userId],
  courseCompletion: (userId) => ['course-completion', userId],
  courseDetail: (courseId, userId) => ['course-detail', courseId, userId || 'guest'],
  coursePricing: (courseId, userId) => ['course-pricing', courseId, userId || 'guest'],
  courseAccessState: (courseId, userId) => ['course-access-state', courseId, userId],
  courseSubmoduleProgress: (userId, courseId) => ['course-submodule-progress', userId, courseId],
  courseCompletionSummary: (userId, courseId) => ['course-completion-summary', userId, courseId],
  // Adaptive journeys (mobile only; all start with ['adaptive', ...]).
  adaptiveJourneys: (userId) => ['adaptive', 'journeys', userId],
  adaptiveJob: (jobId) => ['adaptive', 'job', jobId],
  adaptiveOutline: (journeyId) => ['adaptive', 'outline', journeyId],
  adaptiveModulePages: (moduleId) => ['adaptive', 'module-pages', moduleId],
  adaptivePage: (pageId) => ['adaptive', 'page', pageId],
  adaptivePageAnimations: (pageId) => ['adaptive', 'page-animations', pageId],
  adaptiveQuizProgress: (quizId) => ['adaptive', 'quiz-progress', quizId],
  // XR dashboard (mobile only; the web's older ['xr_courses'] keys are untouched).
  xrCourses: (userId) => ['xr', 'courses', userId],
  xrProgressSummary: (userId) => ['xr', 'progress-summary', userId],
  xrModules: (courseId, userId) => ['xr', 'modules', courseId, userId],
  planUsageStatus: (featureKey) => ['plan-usage-status', featureKey],
  // Same key as the web's useCourseCertificateStatus.
  courseCertificateStatus: (courseId) => ['course-certificate-status', courseId],
};
